import { render, staticRenderFns } from "./RequestLogsTable.vue?vue&type=template&id=ec9185d6&scoped=true"
import script from "./RequestLogsTable.vue?vue&type=script&lang=js"
export * from "./RequestLogsTable.vue?vue&type=script&lang=js"
import style0 from "./RequestLogsTable.vue?vue&type=style&index=0&id=ec9185d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9185d6",
  null
  
)

export default component.exports